import React, { useEffect } from "react";
import { Accordion, FormControl } from "react-bootstrap";
import ControllerMethod from "./ControllerMethod";
const controllerMethods = [
  "index",
  "create",
  "store",
  "show",
  "edit",
  "update",
  "destroy"
];

export default function Controller(props) {
  const [modelSummary, setModelSummary] = React.useState({});

  function updateModelSummary(method, value) {
    const update = { [method]: value };
    const result = { ...modelSummary, ...update };
    setModelSummary(result);
  }

  function getConcatModelSummary() {
    let concatString = "";
    let successCounter = 0;
    for (const [key, value] of Object.entries(modelSummary)) {
      console.log(value);
      if (value.length > 0) {
        successCounter++;
        concatString += value + "\n";
      }
    }
    return successCounter == 0 ? "" : concatString;
  }

  useEffect(() => {
    props.onToggleComplete(props.id, "controllerText", getConcatModelSummary());
  }, [modelSummary]);

  return (
    <div>
      {/* <FormControl
        as="textarea"
        placeholder="Custom action"
        value={getConcatModelSummary()}
        disabled
      /> */}
      <Accordion defaultActiveKey="0">
        {controllerMethods.map((cmethod, ci) => (
          <ControllerMethod
            updateModelSummary={updateModelSummary}
            cmethod={cmethod}
            ci={ci}
          />
        ))}
      </Accordion>
    </div>
  );
}
